export default __webpack_public_path__ + "static/media/customer.f39ed2e7.jpg";